export default "__VITE_ASSET__sQES0w8S__"